export const environment = {
    production: false,
    LogoutURL: "https://login-int.mercedes-benz.com/signout?",
    api: "/api"
};
